import React, { BaseSyntheticEvent } from 'react';
import { styled } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface IStepProps {
  rows: any[];
  setRowData: any;
  colsArr: any[];
  }

const CustomSelect = styled(Select)({
  '.MuiSelect-icon': {
    color: '#BDBEC1'
  },
  'overflow': 'hidden',
  'color': 'var(--Text-Main, #EFF1F6)',
  'textOverflow': 'ellipsis',
  'fontFamily': 'Inter',
  'fontSize': '14px',
  'fontStyle': 'normal',
  'fontWeight': 400,
  'lineHeight': '24px',
  'border': '1px solid #2E3036',
  'height': '48px',
});


const DataMatchStep: React.FC<IStepProps> = ({ rows, setRowData, colsArr }) => {
  const valsArrofObjs: any = [];

  const selectCategory = (e: BaseSyntheticEvent, i: number) => {
    const arr: any = colsArr;
    arr[i].prop = e.target.value;
    rows.forEach((row: any, i: number) => {
      Object.keys(row).forEach((key) => {
        let obj = {};
        if (key) {
          const header = colsArr.find((item: any) => item.val === key);
          obj = {
            type: header.prop,
            searchVal: row[key],
            row: i
          };
        }
        valsArrofObjs.push(obj);
      });
    });
    setRowData(valsArrofObjs);
  };

  return (
    <>
      <div className='bill-container-fit-screen-content-row'>
        <div className='bill-container-fit-screen-content-row-header'>
          <p>1. Please match the column headers of your document to the desired screening category.</p>
        </div>
        <div className='data-match-table'>
          <div className='data-match-header'>
            <div className='data-match-head-content'>Column Name</div>
            <div className='data-match-head-content'>Screening Category</div>
          </div>
          <div className='data-match-rows'>
            {
              colsArr.length === 0 ?
                (
                  <div className='data-match-row'>
                    <div className='data-match-row-col'>No Data Available</div>
                    <div className='data-match-row-col'></div>
                  </div>
                ) : (
                  colsArr.map((col: any, i: number) => (
                    <div className='data-match-row' key={i}>
                      <div className='data-match-row-col'>{col.val}</div>
                      <FormControl sx={{ width: '50%' }}>
                        <CustomSelect
                          value={col.prop}
                          onChange={(e: BaseSyntheticEvent) => selectCategory(e, i)}
                          fullWidth
                          IconComponent={KeyboardArrowDownIcon}
                          inputProps={{
                            MenuProps: {
                              MenuListProps: {
                                sx: {
                                  backgroundColor: '#202227',
                                  color: 'var(--Text-Main, #EFF1F6)',
                                }
                              }
                            }
                          }}
                        >
                          <MenuItem value=''>
                            <em>Select One</em>
                          </MenuItem>
                          <MenuItem value={'bulk'}>Search All</MenuItem>
                          <MenuItem value={'entity'}>People & Companies</MenuItem>
                          <MenuItem value={'code'}>HS Codes</MenuItem>
                          <MenuItem value={'desc'}>Product Descriptions</MenuItem>
                          <MenuItem value={'country'}>Country</MenuItem>
                          <MenuItem value={'address'}>Address</MenuItem>
                          <MenuItem value={'exclude'}>Exclude</MenuItem>
                        </CustomSelect>
                      </FormControl>
                    </div>
                  )))
            }
          </div>
        </div>
      </div>

    </>
  );
};
export default DataMatchStep;
